import type { ReactNode } from 'react';

export const symbol_beenhere: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M461.09-58q-8.92-3-17.09-9L184-262q-11.25-8.25-17.62-21-6.38-12.75-6.38-27v-510q0-24 18-42t42-18h520q24 0 42 18t18 42v510q0 14.25-6.37 27-6.38 12.75-17.63 21L516-67q-8.3 6-17.34 9-9.05 3-18.86 3-9.8 0-18.71-3ZM480-115l260-200v-505H220v505l260 200Zm-43-329-78-78q-9-9-21-9t-21 8.61q-9 9.39-9 21.39t9 21l100 99q9 9 21 9t21-9l184-184q9-9 8.5-21t-9.11-21q-9.39-9-21.39-9t-21 9L437-444Zm43-376H220h520-260Z"
		/>
	</svg>
);
